import { useEffect } from "react";
import { AppLayout } from "@/components/layout/app-layout";
import { initializeAppData } from "@/data/appInitialization";

export default function App() {
  // Initialize app data on mount
  useEffect(() => {
    initializeAppData();
  }, []);

  return (
    <>
      <AppLayout />
    </>
  );
}
